import { Link } from "react-router";

export type GrammaticaCardProps = {
  slug: string;
  /** 1-based card number shown in the badge. */
  index: number;
  title: string;
  tagline: string;
  duration: string;
  /** Already-localized help label, e.g. "Algemeen" / "Helpt bij Schrijven". */
  helpLabel: string;
};

/**
 * Index card linking to a grammar chapter. Hover lifts via transform only
 * (ease-out, no width/shadow-size animation beyond the soft brand shadow).
 */
export function GrammaticaCard({
  slug,
  index,
  title,
  tagline,
  duration,
  helpLabel,
}: GrammaticaCardProps) {
  return (
    <Link
      to={`/grammatica/${slug}`}
      className="group flex h-full flex-col rounded-[var(--radius-lg)] border border-[var(--border)] bg-[var(--panel)] p-5 sm:p-6 transition-[transform,box-shadow,border-color] duration-150 ease-out hover:-translate-y-px hover:border-[var(--border-strong)] hover:shadow-[var(--shadow)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-[var(--accent)] focus-visible:outline-offset-2"
    >
      <div className="flex items-start justify-between gap-3">
        <span className="grid h-[34px] w-[34px] flex-none place-items-center rounded-[10px] bg-[var(--accent-soft)] font-display text-sm font-semibold text-[var(--accent)] tabular-nums">
          {index}
        </span>
        <span className="font-mono-badge text-[11px] text-[var(--ink-faint)] tabular-nums">
          {duration}
        </span>
      </div>
      <h3 className="mt-4 text-lg font-semibold tracking-tight">{title}</h3>
      <p className="mt-2 mb-4 font-serif-italic text-[15px] leading-snug text-[var(--ink-muted)]">
        {tagline}
      </p>
      <div className="mt-auto flex items-center gap-2.5">
        <span className="inline-flex items-center rounded-full bg-[var(--accent-soft)] px-2.5 py-1 font-mono-badge text-[10px] uppercase tracking-wider text-[var(--accent)]">
          {helpLabel}
        </span>
      </div>
    </Link>
  );
}
